// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__s129W","Success":"Button_Success__1bq81","Danger":"Button_Danger__1kjX7"};